module.exports = __webpack_public_path__ + "static/motion-789db697d809f0aad8c908bda2b2a8ab.gif";